import { useHistory, useRouteMatch } from "react-router";
import { Button, Stack } from "@mui/material";

import { useCustomerContext } from "../../../Context/CustomerContext";
import SelectedAccountAndCluster from "../ClusterActivation/Steps/components/SelectedAccountAndCluster";
import { useCluster } from "../hooks";
import { ManageAgent, PageLayout } from "./Components";

const ClusterAgentManagement = () => {
  const { customer } = useCustomerContext();
  const history = useHistory();
  const match = useRouteMatch<{ clusterId: string }>();

  const handleCancel = () => {
    history.push(`/customers/${customer.id}/integrate/assets/kubernetes`);
  };

  const handleDone = () => {
    handleCancel();
  };

  const [cluster, clusterLoading] = useCluster(match.params.clusterId);

  const footer = (
    <Stack spacing={2} direction="row">
      <Button onClick={handleCancel}>Cancel</Button>
      <Button variant="contained" onClick={handleDone}>
        Done
      </Button>
    </Stack>
  );

  const subtitle = !!cluster && (
    <SelectedAccountAndCluster projectId={cluster.projectId ?? ""} selectedClusters={[cluster]} />
  );

  return (
    <PageLayout footer={footer} loading={clusterLoading} title="Manage Agent" subtitle={subtitle}>
      <ManageAgent cluster={cluster} />
    </PageLayout>
  );
};

export default ClusterAgentManagement;
